import React from 'react';
import { SeasonData } from '../../types';
import {
    TABLE_ROW,
    TABLE_HEADER_ROW,
    HEADER_CELL,
    BODY_CELL,
} from '../UI/tableStyles';

interface ManagerPastPlacementsTableType {
    season: SeasonData;
    managerId: string;
}

const ManagerPastPlacementsTable: React.FC<ManagerPastPlacementsTableType> = ({ season, managerId }) => {

    return (
        <div className="overflow-x-auto">
            <table className="w-full min-w-full">
                <thead>
                    <tr className={TABLE_HEADER_ROW}>
                        <th className={`${HEADER_CELL} text-left`}>Manager</th>
                        <th className={`${HEADER_CELL} text-left`}>Total Points</th>
                        <th className={`${HEADER_CELL} text-left`}>Relative Rank</th>
                    </tr>
                </thead>
                <tbody className="text-sm">
                    {season.players.map((player) => (
                        <tr
                            key={player.id}
                            className={`${TABLE_ROW} text-content ${player.id === Number(managerId) ? 'text-accent font-bold' : ''}`}
                        >
                            <td className={`${BODY_CELL} text-left`}>{player.name}</td>
                            <td className={`${BODY_CELL} text-left`}>{player.total_points}</td>
                            <td className={`${BODY_CELL} text-left`}>{player.relative_rank}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ManagerPastPlacementsTable;
